import React from 'react';



interface InputType {

  name : string,
  id : string,
  placeholder: string,
  value: string | null,
  onChange: any,
  required?:boolean

}

function TextArea({name,id,placeholder,value,onChange,required}:InputType) {
  return (

        <textarea name={name} id={id} placeholder={placeholder} value={value!} onChange={onChange} required={required} className = 'focus:outline-primary-color p-1.5 rounded mb-2 bg-slate-100'  />

  )

}

export default TextArea

